<template>
    <div id="task">
        <comheader></comheader>
        <div class="rf ks_right" id="rmodel">
            <comtop></comtop>
            <el-main>
                <div class="com_topaside">
                    <span>培训<b>></b></span>
                    <span>考试管理<b>></b></span>
                    <span>新增学习任务<b></b></span>
                </div>
                <div class="com_typography">
                    <el-input placeholder="请输入内容" v-model="input" class="com_search lf"><i slot="prefix" class="el-input__icon el-icon-search"></i></el-input>
                    <el-button type="primary" class="add_exam" icon="el-icon-plus" @click="hrefto">新增学习任务</el-button>
                    <el-checkbox v-model="checked" class="rf com_checked">只看我创建的</el-checkbox>   
                    <div class="com_task rf">
                         <el-button type="primary" class="task_btn">全部(83)</el-button> 
                         <el-button class="task_btn">未开始(83)</el-button>
                         <el-button class="task_btn">进行中(83)</el-button>
                         <el-button class="task_btn">已结束(83)</el-button>  
                    </div>
                </div>
            </el-main>
            <el-main class="exam_wrap">
                <el-table :data="taskList" border style="width: 100%" class="exam_table"
                ref="multipleTable"
                >
                <el-table-column
                    v-for="info in tHeadr" :key="info.key"     
                    :property="info.key"
                    :label="info.label"
                    :width="info.width"
                >
                <template slot-scope="scope">
                    {{scope.row[scope.column.property]}}  <!-- 渲染对应表格里面的内容 -->
                </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope" class="exam_btn">
                        <el-button @click="handleClick(scope.$index)" type="text" size="large">监控数据</el-button>
                        <el-button type="text" size="large" @click="delexam(scope.$index,scope.row.q_id)" class="exam_delbtn" >删除</el-button>
                        <el-dropdown  @command="handleCommand">
                            <el-button class="el-dropdown-link" type="text">
                                更多<i class="el-icon-arrow-down el-icon--right more-right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown" >
                                <el-dropdown-item @click.native="delay(scope)">延期</el-dropdown-item>
                                <el-dropdown-item @click.native="editPeo">变更</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
                </el-table>
            </el-main>
        </div>
        <el-dialog title="延期时间" :visible.sync="delayTime" custom-class="dialogAddtime">
            <div class="diaowraptime">
                <div class="dialogtime">
                    <span>开始时间：</span>
                    <el-date-picker
                        v-model="s_time"
                        type="datetime"
                        disabled
                       >
                    </el-date-picker>
                </div>
                <div class="dialogtime">
                    <span>结束时间：</span>
                    <el-date-picker
                        v-model="e_time"
                        type="datetime"
                        @focus="endtime"
                        :picker-options="pickerOptionsEnd"
                        placeholder="选择日期时间">
                    </el-date-picker>
                </div>
            </div>
            <div slot="footer" class="dialogtimefoot">
                <el-button type="primary" @click="delayTimeUp">保存</el-button>
                <el-button>取消</el-button>
            </div>
        </el-dialog>
        <el-dialog title="变更" :visible.sync="changeArr" custom-class="dialogAddtime">
            <div class="diaowrapArr">
                可见范围：<el-radio v-model="radio" label="1">全部</el-radio><el-radio v-model="radio" label="2">部门/人员</el-radio>
                <el-button type="primary" v-show="radio==2"><i class="el-icon-plus"></i>添加</el-button>
            </div>
            <div class="diaowrapArr">
                已选学员：<el-tag
                            type="info"
                            effect="plain">
                            许凤英
                        </el-tag>
            </div>
            <div class="diaowrapArr">
                <p>提示：新增学员会收到任务通知，移除的学员会收到任务撤销通知，已指派人员不再收到任务</p>
            </div>
            <div slot="footer" class="dialogtimefoot">
                <el-button type="primary" @click="delayTimeUp">确定</el-button>
                <el-button>取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import comheader from '../Common/comheader'
import comtop from '../Common/comtop'
 export default{
    name:'questionIndex',
    data(){
        return{
            input:'',
            checked:false,
            taskList:[],
            delayTime:false,
            s_time:'',
            id:'',
            radio:'1',
            pickerOptionsEnd: {},
            e_time:'',
            changeArr:false,
            tHeadr: [
                {
                    label: '学习任务名称',
                    key: 'title',
                    width:'420'
                },
                {
                    label: '学员',
                    key: 'examinee',
                    width:'160 '
                },
                {
                    label: '已学习',
                    key: 'pscore',
                    width:'148 '
                },
                {
                    label:'未学习 ',
                    key:'lscore',
                    width:'148'
                },
                {
                    label:'创建人',
                    key:'create_name',
                    width:'83'
                },
                {
                    label:'创建时间',
                    key:'s_time',
                    width:'132'
                },
                {
                    label:'学习任务结束时间',
                    key:'e_time',
                    width:'276'
                }
            ],
        }
    },
    components:{
        comheader,
        comtop
    },
    methods:{
        hrefto(){
            this.$router.push({ path:'/addlearning'})
        },
        delexam(i,id){
            // console.log(id)
            // var btn = document.getElementsByClassName('exam_delbtn')
            // var data={
            //     service:'Question.QsnDel',
            //     id:id
            // }
            const h = this.$createElement;
            this.$msgbox({
                title: '消息',
                message: h('p', null, [
                h('span', null, '是否确定删除')
                ]),
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                showCancelButton:true,
                lockScroll:false,
                showClose:false,
                customClass:'delBtn',
            }).then(action => {
                    this.taskList.splice(i,1)
                    this.alertView.successView('删除成功')
            });
        },
        handleCommand(command){
            console.log(command)
        },
        delay(val){
            this.s_time=val.row.s_time
            this.delayTime=true
            this.id=val.row.c_id
        },
        editPeo(){
            this.changeArr=true
        },
        endtime(){
            let stime=this.s_time
            this.pickerOptionsEnd = Object.assign({}, this.pickerOptionsEnd, {                 
                disabledDate(time){
                    return time.getTime() < new Date(stime).getTime();
            }})
        },
        delayTimeUp(){
            var dataUp={
                service:'Examtask.Delay',
                id:this.id,
                etime:this.e_time,
                userid:localStorage.getItem('userid')
            }
            this.$axios.post(this.HOME,this.$qs.stringify(dataUp))
            .then(res=>{
                for(let i=0 ;i <res.data.data.length;i++){
                data.push(res.data.data[i])
                }
                this.taskList=data
            })
                .catch(function (error) { // 请求失败处理
                console.log(error)
            });  
        }
    },
    mounted(){
    var data=[]
    var dataUp= {
        service:'Study.TaskList',
        userid: localStorage.getItem('userid'),
        page:1,
        limit:10
    }
        this.$axios.post(this.HOME,this.$qs.stringify(dataUp))
            .then(res=>{
                for(let i=0 ;i <res.data.data.info.length;i++){
                    data.push(res.data.data.info[i])
                }
                    this.taskList=data
            })
                .catch(function (error) { // 请求失败处理
            });  
    }
 }
</script>
<style>
    @import "../../assets/css/task.css";
</style>


// WEBPACK FOOTER //
// src/components/questionnaire/index.vue